import '../Dashboard.css';
import React from "react";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
// import apiinfo from '../../utils/base-uri.json';
import axios from "../../../utils/fvAxios";
// import { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from '@mui/system';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { CompaniesProvider } from '../../../store/companies-context';
import Nodata from '../../Nodata/Nodata';
import PreqAnalytics from './PreqAnalytics';




const white = {
    50: '#fff',
    100: '#fff',
    200: '#fff',
    300: '#fff',
    400: '#fff',
    500: '#F2F4F7',
    600: '#030202',
    700: '#0059B2',
    800: '#fff',
    900: '#fff',
  };
  
  const Tab = styled(TabUnstyled)`
    font-family: IBM Plex Sans, sans-serif;
    color: black;
    cursor: pointer;
    font-size: 0.875rem;
    font-weight: bold;
    background-color: transparent;
    width: 100%;
    padding: 10px 5px;
    margin: 6px 6px;
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: center;
  
    &:hover {
      background-color: ${white[400]};
    }
  
    &:focus {
      color: #fff;
      border-radius: 3px;
      outline: 2px solid ${white[200]};
      outline-offset: 2px;
    }
  
    &.${tabUnstyledClasses.selected} {
      background-color: ${white[50]};
      color: ${white[600]};
    }
  
    &.${buttonUnstyledClasses.disabled} {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `;
  
  const TabPanel = styled(TabPanelUnstyled)`
    width: 100%;
    font-family: IBM Plex Sans, sans-serif;
    font-size: 0.875rem;
  `;
  
  const TabsList = styled(TabsListUnstyled)`
    min-width: 320px;
    background-color: ${white[500]};
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: space-between;
  `;
export default function PrequlificationAnalyticsTab() {
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [token, setToken] = useState("");
    const [preqList, setPreqList] = useState([]);
    const [index, setIndex] = React.useState(0);
    const [alignment, setAlignment] = React.useState("");
    
    // useEffect(() => {
    //   axios.get(apiinfo.Metrics.DashboardMetrics,
    //   ).then(res => {
    //     setDetails(res.data.data.embedReports)
    //     setToken(res.data.data.embedToken.token)
    //   }).catch(err => {
    //     console.log(err)
    //   })
    // }, []);

  
    const handleChange = (newAlignment, i) => {
        setAlignment(newAlignment);
        setIndex(i);
      };
      useEffect(() => {
        axios.get("Prequalification/GetExternalPowerBIReportList"
        ).then((res) => {
          if (res?.data?.responseCode === 100) {
            const data = res?.data?.data;
            setPreqList(data?.value)
            setAlignment(data?.value[0]?.powerBiReportId);
         
            // setSelectedValue(data[0]?.key);
    
          }
          else {
            setError(res.data.responseMessage);
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          setIsLoading(false);
        });
    
    
      }, []);
  return (
    <>

<Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    <div className="row" >
    <p style={{float:"left",marginBottom:"20px",fontSize:"24px",fontWeight:"500"}}>Prequalification Analytics</p>
        <CompaniesProvider>
          <TabsUnstyled defaultValue={index} sx={{ backgroundColor: "#fff" }}>
      
          <br />
            <TabsList sx={{ width: "auto" }}>
              {preqList?.map((r, i) => (
                <Tab key={r?.powerBiReportId} onClick={() => handleChange(r?.powerBiReportId, i)}>{r?.displayName}</Tab>
              ))}
            </TabsList>

            <TabPanel value={index} >
                {/* <EditclientIntrocontent Alignments={alignment} orgs={org} refe={refresh}/> */}
                <PreqAnalytics Alignments={alignment}  />
                </TabPanel>


          </TabsUnstyled>
        </CompaniesProvider>

      </div>
      <div hidden={preqList?.length!=0||isLoading==true}><Nodata/></div>
    {/* {details.map((r, index) =>
      <PowerBIEmbed
      style={{marginTop:"none",height:"100%"}}
        key={index}
        embedConfig={{
          type: 'report',
          id: r.reportId,
          embedUrl: r.embedUrl,
          accessToken: token,
          tokenType: models.TokenType.Embed,
          settings: {
            panes: {
              filters: {
                expanded: false,
                visible: true
              },
              bars: {
                statusBar: {
                    visible: false
                }
            }
      
            },
          }
        }}

        eventHandlers={
          new Map([
            ['loaded', function () { console.log('Report loaded'); }],
            ['rendered', function () { console.log('Report rendered'); }],
            ['error', function (event) { console.log(event.detail); }]
          ])
        }

        cssClassName={"embed_container"}
        

        getEmbeddedComponent={(embeddedReport) => {
          window.report = embeddedReport;
        }}
      />
    )} */}
  </>
  )
}
